/**
 * Listen for logout events from other tabs
 * @param callback Function to execute when logout is detected
 */
export const listenForCrossTabLogout = (callback: () => void) => {
  if (typeof window === 'undefined') return

  const handleStorageChange = (event: StorageEvent) => {
    if (event.key === 'logoutEvent') {
      callback()
    }
  }

  window.addEventListener('storage', handleStorageChange)

  // Return cleanup function
  return () => {
    window.removeEventListener('storage', handleStorageChange)
  }
}

/**
 * Check if user is logged out by checking for auth tokens
 * @returns boolean indicating if user is logged out
 */
export const isLoggedOut = (): boolean => {
  if (typeof window === 'undefined') return true

  // Check for auth tokens in cookies or localStorage
  const hasAuthToken =
    document.cookie.includes('authToken') ||
    document.cookie.includes('koloToken') ||
    localStorage.getItem('authToken') ||
    localStorage.getItem('userToken')

  return !hasAuthToken
}
